import(/* webpackMode: "eager" */ "/vercel/path0/web/app/dashboard/page.tsx");
